export default __webpack_public_path__ + "static/media/color_notext.7e1004a6.png";